

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrder, EOrderTypes} from "@/model/Order/orderInterfaces";
import Order from '@/views/order/Order.vue';


  @Component({
    name: 'OOProfessionalServicePrice',
    components: {
    }
  })
  export default class OOProfessionalServicePrice extends Vue {

    @Prop()
    protected order!: IOrder;

    // Computed properties para manejar los datos del servicio profesional
    protected get servicePrice(): number {
        // Como fallback, usar el grand_total
         if (this.order.professional_service_data) {
            return this.order.professional_service_data.serviceProvider.service_price || 0;
         }
         return 0;

    }

    protected get calculationUnit(): string {
      if (this.order.professional_service_data) {
        return String(this.$t('orders.order.professional_service.calculation_units.' + this.order.professional_service_data.serviceProvider.calculation_unit)) || 'NaN';
      }
      return 'NaN';
    }

    protected get quantity(): number {
      // Intentar obtener la cantidad del primer servicio o usar 1 por defecto
      if (this.order.professional_service_data) {
        return this.order.professional_service_data.details.quantity || 1;
      }
      return 1;
    }

    protected get grandTotal(): string {
      return this.order.grand_total || '0';
    }

    protected get isProfessionalService(): boolean {
      return this.order.type === EOrderTypes.professional_service;
    }

  }

